export default __webpack_public_path__ + "static/media/404.70dd39f2.svg";